export class LogsSchemasResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "entries",
            "baseName": "entries",
            "type": "Array<LogsSchemaEntry>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return LogsSchemasResponse.attributeTypeMap;
    }
    constructor() {
    }
}
